import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"
import { monitorAction, monitorError } from "../lib/datadog_monitoring"

// Connects to data-controller="tom-select"
export default class extends Controller {
  static values = {
    items: Array,
    create: false,
    maxItems: { type: Number, default: 20 },
    maxOptions: { type: Number, default: 50 },
  }

  connect() {
    // Prevent re-initialization if already initialized.
    if (this.element.tomselect) return

    const settings = {
      items: this.itemsValue,
      create: this.createValue,
      persist: false,
      closeAfterSelect: true,
      maxItems: this.maxItemsValue,
      maxOptions: this.maxOptionsValue,
      plugins: {
        remove_button: {
          title: "Remove",
        },
      },
    }

    try {
      new TomSelect(this.element, settings)

      if (this.element.name === "job_post[job_title]") {
        this.element.dataset.tomSelectInitialized = "true"

        monitorAction("job_post.job_title.tom_select_initialized", {
          pathname: window.location.pathname,
          max_items: this.maxItemsValue,
          create_enabled: this.createValue
        })
      }
    } catch (error) {
      if (this.element.name === "job_post[job_title]") {
        monitorError("TomSelect failed to initialize for job title", {
          pathname: window.location.pathname,
          field_name: this.element.name
        }, error)
      }

      throw error
    }
  }

  disconnect() {
    // Clean up instance to avoid leaks and allow re-init later.
    if (this.element.tomselect) {
      this.element.tomselect.destroy()
    }
  }
}
